// extracted by mini-css-extract-plugin
export default {"caption":"LopListContainer_caption__FMszk","container":"LopListContainer_container__wCYCF","actions":"LopListContainer_actions__olDpf","space":"LopListContainer_space__4EHMq"};